import {createAction, handleActions} from "redux-actions";
import createRequestSaga, {createRequestActionTypes} from "../lib/createRequestSaga";
import * as agreeAPI from "../lib/api/agree";
import { throttle } from 'redux-saga/effects';

const SET_AGREE_DATA = 'agree/SET_AGREE_DATA';
const SET_IS_COMPLETE_SAVE = 'agree/SET_IS_COMPLETE_SAVE';
const SET_IS_VALID = 'agree/SET_IS_VALID';
const CLEAR_KOGNR_SEQ = 'agree/CLEAR_KOGNR_SEQ';
const CHANGE_STEP = 'agree/CHANGE_STEP';

const [SAVE, SAVE_SUCCESS, SAVE_FAILURE] = createRequestActionTypes('agree/SAVE');

export const saveAgree = createAction(SAVE, null);
export const setIsCompleteSave = createAction(SET_IS_COMPLETE_SAVE, flag => flag);
export const setIsValid = createAction(SET_IS_VALID, flag => flag);
export const clearKognrSeq = createAction(CLEAR_KOGNR_SEQ);
export const setAgreeData = createAction(SET_AGREE_DATA, agree => agree);
export const changeStep = createAction(CHANGE_STEP, step => step );

const saveAgreeSaga = createRequestSaga(SAVE, agreeAPI.saveAgree);
export function* agreeSaga() {
    yield throttle(2000, SAVE, saveAgreeSaga);
}

const initialState = {
    agree: null,
    step: 0,
    isCompleteSave: false,
    isValid: false,
    kognrSeq: ""
};

const agree = handleActions(
    {
        [SET_AGREE_DATA]: (state, action) => ({
            ...state,
            agree: action.payload
        }),
        [SET_IS_COMPLETE_SAVE]: (state, action) => ({
            ...state,
            isCompleteSave: action.payload
        }),
        [SET_IS_VALID]: (state, action) => ({
            ...state,
            isValid: action.payload
        }),
        [CLEAR_KOGNR_SEQ]: (state, action) => ({
            ...state,
            kognrSeq: ""
        }),
        [CHANGE_STEP]: (state, action) => ({
            ...state,
            step: action.payload.step
        }),
        [SAVE_SUCCESS]: (state, {payload: data}) => ({
            ...state,
            isCompleteSave: true,
            kognrSeq: data.kognrSeq
        }),
        [SAVE_FAILURE]: (state, {payload: error}) => ({
            ...state,
            isCompleteSave: false,
            kognrSeq: ""
        })
    },
    initialState
);

export default agree;
